"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresenceListener = void 0;
class PresenceListener {
    constructor(options) {
        this.presence = {};
        // Time of the last update caused by a state change.
        this.lastUpdate = 0;
        this.nextUpdate = Date.now();
        this.state = options.initialState;
        this.db = options.db;
        this.key = options.key ?? "__presence";
        this.clientId = options.clientId;
        this.callback = options.callback ?? (() => { });
        this.minPresenceInterval = options.minPresenceInterval ?? 20; // 20 ms
        this.maxPresenceInterval = options.maxPresenceInterval ?? 1000; // 1 second
        this.updateHandle = setTimeout(() => {
            this.update();
        }, 0);
        this.onMessage = this.onMessage.bind(this);
        this.db.subscribe(this.key, this.onMessage);
        this.interval = setInterval(() => {
            for (let client in this.presence) {
                if (Date.now() - this.presence[client].lastSeen > this.maxPresenceInterval * 2) {
                    delete this.presence[client];
                }
            }
        }, this.maxPresenceInterval);
    }
    destroy() {
        clearInterval(this.interval);
        clearTimeout(this.updateHandle);
        this.db.unsubscribe(this.key, this.onMessage);
    }
    onMessage(event) {
        let message = event.value;
        if (message.client === this.clientId) {
            // Ignore our own messages.
            return;
        }
        this.presence = {
            ...this.presence,
            [message.client]: {
                value: message.value,
                lastSeen: Date.now()
            }
        };
        this.callback(this.presence);
    }
    update() {
        this.db.send({
            type: "push",
            action: { type: "relay" },
            value: { value: this.state, client: this.clientId },
            key: this.key
        });
        this.nextUpdate = Date.now() + this.maxPresenceInterval;
        this.lastUpdate = Date.now();
        this.updateHandle = setTimeout(() => {
            this.update();
        }, this.maxPresenceInterval);
    }
    updateState(value) {
        if (JSON.stringify(value) === JSON.stringify(this.state)) {
            return;
        }
        this.state = value;
        const nextUpdate = this.lastUpdate + this.minPresenceInterval;
        if (nextUpdate < this.nextUpdate) {
            this.nextUpdate = nextUpdate;
            clearTimeout(this.updateHandle);
            this.updateHandle = setTimeout(() => {
                this.update();
            }, this.nextUpdate - Date.now());
        }
    }
}
exports.PresenceListener = PresenceListener;
